import _set from 'lodash-es/set';

import { EventEmitter, Injectable } from '@angular/core';


/**
 * Form Builder Service
 * Usage : emit events to be catch by apps
 *
 * used by APIService
 * @deprecated
 */
@Injectable()
export class FormBuilderService {

    public submitForm: EventEmitter<string> = new EventEmitter();
    public submitNamedForm: EventEmitter<any> = new EventEmitter();
    public closeNamedForm: EventEmitter<any> = new EventEmitter();
    public info: EventEmitter<string> = new EventEmitter();
    public focusEvent: EventEmitter<string> = new EventEmitter();


    public firstOpening: any = {};

    /**
     *
     * first form emit when submit
     */
    public emitSubmitForm(_data: any) {
        this.submitForm.emit(_data);
    }

    public setFirstOpening(_formName: string) {
        _set(this.firstOpening, _formName, true);
    }

    public isFirstOpening(_formName: string) {
        return this.firstOpening[_formName];
    }

    /**
     *
     * first form emit when submit wasn't enough
     * with name, will be better
     */
    public emitSubmitFormWithName(_formName: string, _data: any) {
        this.submitNamedForm.emit({formName: _formName, data: _data});
    }

    /**
     *
     * event to Close Form
     * with name, will be better
     */
    public emitCloseFormWithName(_formName: string, _index: number = -1) {
        if (_index === -1) {
            this.closeNamedForm.emit({formName: _formName});
        } else {
            this.closeNamedForm.emit({
                formName: _formName,
                index: _index,
            });
        }
    }

    /**
     *
     * anu info EventEmitter
     * @param: {key: value}
     */
    public emitInfo(_data: any) {
        this.info.emit(_data);
    }

    /**
     *
     * emit focus with Name
     * @param: _name: string
     */
    public emitFocusEvent(_focusName: any) {
        this.focusEvent.emit(_focusName);
    }
}
